import React from "react";
import { Link } from "react-router";

import FlexibleTable from "../../modules/FlexibleTable";
import ModalWindow from "../../modules/ModalWindow";
import TableCentricPage from "../../modules/TableCentricPage";
import TableCentricPageButton from "../../modules/TableCentricPageButton";
import Separator from "../../modules/Separator";
import DeleteButton from "../../modules/DeleteButton";
import EditButton from "../../modules/EditButton";

import Api from "../../utils/Api";
import TableLeftPanel from "../../utils/TableLeftPanel";

class AddBridge extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = { name: "" };
  }

  handleHide = () => {
    this.props.handleClose();
  };

  handle_ChangeName = (event) => {
    this.setState({ name: event.target.value });
  };

  handle_Submit = () => {
    this.props.handleAdd(this.state.name);
    this.handleHide();
  };

  renderActions = () => {
    return (
      <button type="submit" className="mui-btn mui-btn--raised" onClick={this.handle_Submit}>
        Add
      </button>
    );
  };

  render() {
    if (this.props.visible) {
      return (
        <ModalWindow title="Add MDNS Bridge" handleHide={this.handleHide} actions={this.renderActions()}>
          <form className="mui-form">
            <div className="formgroup-element-title">Name</div>
            <div className="mui-textfield">
              <input type="text" value={this.state.name} onChange={this.handle_ChangeName} />
            </div>
          </form>
        </ModalWindow>
      );
    }

    return <div></div>;
  }
}

export default class Mdns extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      mdns: [],
      visible__add_group: false,
      loaded: false,
    };
  }

  handle_load = () => {
    const self = this;
    self.setState({
      loaded: false,
    });

    Api.get("/edgewize/ajax/mdns", function (result) {
      self.setState({
        mdns: result["data"],
        loaded: true,
      });
    });
  };

  componentDidMount() {
    this.handle_load();
  }

  handler__clickAdd = () => {
    this.setState({
      visible__add_permission: true,
    });
  };

  handler__clickCloseAdd = () => {
    this.setState({
      visible__add_permission: false,
    });
  };

  render__buttons = () => {
    return <TableCentricPageButton title="Add MDNS Bridge" onClickHandler={this.handler__clickAdd}></TableCentricPageButton>;
  };

  handle_Delete = (id) => {
    const self = this;
    Api.delete("/edgewize/ajax/mdns", { id: id }, function (result) {
      self.handle_load();
    });
  };

  handle__AddGroup = (name) => {
    const self = this;
    Api.put("/edgewize/ajax/mdns", { name: name }, function (result) {
      self.handle_load();
    });
  };

  render__content = () => {
    return;
  };

  render() {
    const self = this;
    const columns = [
      {
        title: "Name",
        data: function (row) {
          return <Link to={"/edgewize/device/mdns/" + row["id"]}>{row["name"]}</Link>;
        },
        sortable: FlexibleTable.sortable__single_caseinsensitive_string_field("name"),
        onclick: undefined,
        search: FlexibleTable.search__single_string_field("name"),
      },
      {
        title: "Operations",
        data: function (row) {
          return (
            <div>
              <EditButton to={"/edgewize/device/mdns/" + row["id"]}></EditButton>
              <Separator />
              <DeleteButton onClick={() => self.handle_Delete(row["id"])}></DeleteButton>
            </div>
          );
        },
        onclick: undefined,
      },
    ];

    return (
      <TableLeftPanel>
        <AddBridge
          visible={this.state.visible__add_permission}
          handleAdd={this.handle__AddGroup}
          handleClose={this.handler__clickCloseAdd}
        ></AddBridge>

        <TableCentricPage icon="fa fa-mobile" title="MDNS Bridge" buttons={this.render__buttons()}>
          <FlexibleTable columns={columns} data={this.state.mdns} loaded={this.state.loaded} />
        </TableCentricPage>
      </TableLeftPanel>
    );
  }
}
